import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "a45deb9c-0cd3-47d8-a8e1-1155731dfd69", // Your Client ID
    authority: "https://login.microsoftonline.com/fcb2b37b-5da0-466b-9b83-0014b67a7c78", // Your Tenant ID
    redirectUri: "https://uat.commplan-np.int.bayer.com/login", // Ensure this matches your app's base URL
  },
  cache: {
    cacheLocation: "sessionStorage",
  storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
  grant_type: "authorization_code",
};
